export const colors = {
    background: "#e8e5f1",
    border: "#8c87a1",
    text: "#262233",
    muted: "#4e4a5f",
    danger: "#ff252d",
    success: "#00b83f",
    progress: "#1473e6",
    white: "#ffffff"
};

export const styles = {
    page: {
        alignItems: "center",
        backgroundColor: colors.background,
        color: colors.text,
        display: "flex",
        fontFamily: "Arial, Helvetica, sans-serif",
        justifyContent: "center",
        height: "100vh",
        overflow: "hidden",
        padding: "clamp(0.75rem, 2vh, 1.5rem)",
        width: "100%",
        boxSizing: "border-box"
    },
    panel: {
        border: `2px solid ${colors.border}`,
        display: "flex",
        flexDirection: "column",
        gap: "clamp(0.55rem, 1.8vh, 1.4rem)",
        height: "calc(100vh - clamp(1.5rem, 4vh, 3rem))",
        maxHeight: "calc(100vh - clamp(1.5rem, 4vh, 3rem))",
        padding: "clamp(0.55rem, 1.4vh, 1rem) clamp(0.75rem, 1.4vw, 1.35rem)",
        position: "relative",
        width: "min(96vw, 1800px)",
        boxSizing: "border-box"
    },
    header: {
        alignItems: "center",
        border: `1px solid ${colors.border}`,
        display: "grid",
        gridTemplateColumns: "1fr auto",
        minHeight: "clamp(2.4rem, 5vh, 4.5rem)"
    },
    title: {
        borderRight: `1px solid ${colors.border}`,
        fontSize: "clamp(1rem, 2vw, 2rem)",
        fontWeight: 800,
        lineHeight: 1,
        margin: 0,
        padding: "clamp(0.4rem, 0.9vh, 0.8rem) clamp(0.5rem, 1vw, 1rem)",
        textAlign: "center"
    },
    dateTime: {
        fontSize: "clamp(0.9rem, 1.35vw, 1.45rem)",
        fontWeight: 700,
        padding: "clamp(0.4rem, 0.9vh, 0.8rem) clamp(0.5rem, 1vw, 1rem)",
        whiteSpace: "nowrap"
    },
    refreshControl: {
        alignItems: "center",
        display: "flex",
        gap: "0.6rem",
        justifyContent: "flex-end"
    },
    averageModeButton: {
        backgroundColor: "transparent",
        border: `1px solid ${colors.border}`,
        borderRadius: "0.25rem",
        color: colors.muted,
        cursor: "pointer",
        fontSize: "clamp(0.72rem, 0.9vw, 0.9rem)",
        fontWeight: 700,
        marginRight: "0.4rem",
        padding: "0.35rem 0.65rem"
    },
    averageModeButtonActive: {
        backgroundColor: colors.white,
        color: colors.text
    },
    refreshLabel: {
        color: colors.muted,
        fontSize: "clamp(0.78rem, 1vw, 1rem)",
        fontWeight: 700
    },
    refreshSelect: {
        backgroundColor: colors.white,
        border: `1px solid ${colors.border}`,
        color: colors.text,
        fontSize: "clamp(0.82rem, 1vw, 1rem)",
        fontWeight: 700,
        padding: "0.35rem 0.55rem"
    },
    productionPanel: {
        display: "flex",
        flexDirection: "column",
        gap: "0.35rem"
    },
    productionHeader: {
        alignItems: "center",
        display: "grid",
        gap: "clamp(0.75rem, 2vw, 2.5rem)",
        gridTemplateColumns: "repeat(4, 1fr)"
    },
    productionMetric: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "0.15rem"
    },
    productionLabel: {
        color: colors.muted,
        fontSize: "clamp(0.72rem, 0.9vw, 0.95rem)",
        fontWeight: 700
    },
    productionValue: {
        color: colors.text,
        fontSize: "clamp(1.35rem, 2.2vw, 2.5rem)",
        fontWeight: 900,
        lineHeight: 1,
        whiteSpace: "nowrap"
    },
    productionTrack: {
        backgroundColor: colors.white,
        border: `1px solid ${colors.border}`,
        borderRadius: "0.45rem",
        height: "clamp(2rem, 4.5vh, 3rem)",
        overflow: "hidden",
        width: "100%"
    },
    productionProgress: {
        alignItems: "center",
        backgroundColor: colors.progress,
        borderRadius: "0.35rem",
        color: colors.white,
        display: "flex",
        fontSize: "clamp(0.9rem, 1.2vw, 1.25rem)",
        fontWeight: 800,
        height: "100%",
        justifyContent: "center",
        overflow: "hidden",
        textShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
        whiteSpace: "nowrap"
    },
    productionProgressNear: {
        backgroundColor: "#236fc7"
    },
    productionProgressReached: {
        backgroundColor: "#268447"
    },
    content: {
        alignItems: "stretch",
        display: "grid",
        flex: 1,
        gap: "clamp(1rem, 4vw, 5rem)",
        gridTemplateColumns: "minmax(24rem, 1fr) minmax(26rem, 1.1fr)",
        minHeight: 0
    },
    groupsArea: {
        display: "grid",
        gap: "clamp(1rem, 3vw, 4rem)",
        gridTemplateColumns: "1fr 1fr",
        minHeight: 0
    },
    groupsColumn: {
        display: "flex",
        flexDirection: "column",
        gap: "clamp(0.65rem, 2.6vh, 2.4rem)",
        minHeight: 0
    },
    groupBox: {
        border: `1px solid ${colors.border}`,
        display: "flex",
        flexDirection: "column",
        minHeight: "clamp(5.4rem, 13vh, 9rem)"
    },
    groupHeader: {
        alignItems: "center",
        borderBottom: `1px solid ${colors.border}`,
        display: "flex",
        fontSize: "clamp(0.95rem, 1.6vw, 1.7rem)",
        fontWeight: 800,
        justifyContent: "center",
        minHeight: "clamp(1.9rem, 4vh, 3rem)"
    },
    groupValue: {
        alignItems: "center",
        color: colors.white,
        display: "flex",
        flex: 1,
        fontSize: "clamp(1.35rem, 2.9vw, 3rem)",
        fontWeight: 800,
        justifyContent: "center",
        minHeight: "clamp(3.3rem, 8.6vh, 6.2rem)",
        textShadow: "0 1px 2px rgba(0, 0, 0, 0.32)"
    },
    groupTrend: {
        fontSize: "0.36em",
        marginLeft: "0.7em",
        opacity: 0.65,
        textShadow: "none"
    },
    groupBreaks: {
        backgroundColor: colors.white,
        color: colors.muted,
        display: "flex",
        flexDirection: "column",
        fontSize: "clamp(0.68rem, 0.9vw, 0.9rem)",
        fontWeight: 700,
        gap: "0.12rem",
        lineHeight: 1.1,
        padding: "0.35rem 0.5rem",
        textAlign: "center"
    },
    generalBox: {
        alignSelf: "stretch",
        border: `1px solid ${colors.border}`,
        display: "flex",
        flexDirection: "column",
        marginTop: "0.2vh",
        minHeight: 0
    },
    generalHeader: {
        alignItems: "center",
        borderBottom: `1px solid ${colors.border}`,
        color: colors.muted,
        display: "flex",
        fontSize: "clamp(0.85rem, 1.1vw, 1.2rem)",
        fontWeight: 700,
        justifyContent: "center",
        minHeight: "clamp(2.4rem, 7vh, 4.8rem)"
    },
    generalValue: {
        alignItems: "center",
        color: colors.white,
        display: "flex",
        flex: 1,
        fontSize: "clamp(4rem, 7.5vw, 9rem)",
        fontWeight: 800,
        justifyContent: "center",
        lineHeight: 1,
        textShadow: "0 2px 4px rgba(0, 0, 0, 0.38)"
    },
    generalTrend: {
        fontSize: "0.22em",
        marginLeft: "0.8em",
        opacity: 0.6,
        textShadow: "none"
    },
    generalBreaks: {
        backgroundColor: colors.white,
        color: colors.muted,
        display: "flex",
        flexDirection: "column",
        fontSize: "clamp(0.9rem, 1.35vw, 1.45rem)",
        fontWeight: 800,
        gap: "0.25rem",
        lineHeight: 1.1,
        padding: "clamp(0.45rem, 1vh, 0.8rem)",
        textAlign: "center"
    },
    status: {
        bottom: "1vh",
        color: colors.muted,
        fontSize: "clamp(0.9rem, 1.2vw, 1.1rem)",
        fontWeight: 700,
        position: "absolute",
        right: "1vw"
    },
    errorPanel: {
        alignItems: "center",
        backgroundColor: colors.danger,
        color: colors.white,
        display: "flex",
        flexDirection: "column",
        gap: "4vh",
        justifyContent: "center",
        minHeight: "calc(100vh - clamp(1.5rem, 4vh, 3rem))",
        padding: "5vh 5vw",
        textAlign: "center",
        width: "min(96vw, 1800px)",
        boxSizing: "border-box"
    },
    errorTitle: {
        fontSize: "clamp(3.8rem, 8vw, 9rem)",
        fontWeight: 900,
        lineHeight: 1,
        textShadow: "0 3px 6px rgba(0, 0, 0, 0.35)"
    },
    errorMessage: {
        fontSize: "clamp(2rem, 4vw, 4.8rem)",
        fontWeight: 800,
        lineHeight: 1.15,
        maxWidth: "90vw",
        overflowWrap: "anywhere",
        textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)"
    }
};

export const getResponsiveStyles = (maxGroupsPerColumn, viewportWidth) => {
    if (viewportWidth <= 900) {
        return {
            page: {
                alignItems: "flex-start",
                height: "auto",
                minHeight: "100vh",
                overflow: "visible",
                padding: "0.5rem"
            },
            panel: {
                gap: "0.75rem",
                height: "auto",
                maxHeight: "none",
                padding: "0.6rem",
                width: "100%"
            },
            header: {
                gridTemplateColumns: "1fr"
            },
            title: {
                borderBottom: `1px solid ${colors.border}`,
                borderRight: 0,
                fontSize: "clamp(0.95rem, 5vw, 1.35rem)",
                lineHeight: 1.2,
                padding: "0.75rem 0.5rem"
            },
            dateTime: {
                fontSize: "clamp(0.78rem, 3.5vw, 1rem)",
                padding: "0.65rem 0.4rem",
                textAlign: "center",
                whiteSpace: "normal"
            },
            refreshControl: {
                flexWrap: "wrap",
                justifyContent: "center"
            },
            productionHeader: {
                gap: "0.65rem",
                gridTemplateColumns: "repeat(2, 1fr)"
            },
            productionTrack: {
                height: "2rem"
            },
            content: {
                display: "flex",
                flexDirection: "column",
                gap: "1rem"
            },
            groupsArea: {
                gap: "0.75rem",
                gridTemplateColumns: "1fr"
            },
            groupsColumn: {
                gap: "0.75rem"
            },
            groupBox: {
                minHeight: "5rem"
            },
            groupHeader: {
                fontSize: "clamp(0.9rem, 4vw, 1.15rem)",
                minHeight: "2.25rem"
            },
            groupValue: {
                fontSize: "clamp(1.5rem, 8vw, 2.25rem)",
                minHeight: "3.5rem"
            },
            groupBreaks: {
                fontSize: "0.8rem"
            },
            generalBox: {
                minHeight: "8rem"
            },
            generalHeader: {
                minHeight: "2.5rem"
            },
            generalValue: {
                fontSize: "clamp(3rem, 18vw, 5rem)",
                minHeight: "6rem",
                padding: "0.5rem"
            },
            generalBreaks: {
                fontSize: "1rem"
            },
            status: {
                alignSelf: "flex-end",
                position: "static"
            },
            errorPanel: {
                minHeight: "calc(100vh - 1rem)",
                width: "100%"
            },
            errorTitle: {
                fontSize: "clamp(2rem, 12vw, 4rem)"
            },
            errorMessage: {
                fontSize: "clamp(1.25rem, 7vw, 2.5rem)"
            }
        };
    }

    if (maxGroupsPerColumn <= 3) return {};

    return {
        groupsColumn: {
            gap: "clamp(0.45rem, 1.8vh, 1.5rem)"
        },
        groupBox: {
            minHeight: "clamp(4.4rem, 10.8vh, 7.2rem)"
        },
        groupHeader: {
            fontSize: "clamp(0.82rem, 1.3vw, 1.35rem)",
            minHeight: "clamp(1.6rem, 3.2vh, 2.4rem)"
        },
        groupValue: {
            fontSize: "clamp(1.15rem, 2.35vw, 2.45rem)",
            minHeight: "clamp(2.7rem, 7.2vh, 4.8rem)"
        }
    };
};
